export default {
    
    methods: {
        loadtestCart: function(){
            console.log('DDD = ');
        },
        checkAuthentication: function(token) {
            //this.isLoading = true;
            let responseData=false;
            let config = {
                method: "GET",
                url: this.$api + 'api/check-authentication',
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            };

            this.$axios(config).then(response => {
                let data = response.data;
                //this.auth = data;
                if(data.status == 200) {
                    //this.checkAuth = true;
                    responseData=true;
                    return responseData;
                }
            }).catch(error => {
                console.log(error);
                //this.isLoading = false;
                responseData=false;
                return responseData;
            });

            // this.$axios.get(this.$api + 'api/check-authentication').then(response => {
            //     let data = response.data;
            //     //this.auth = data;
            //     if(data.status == 200) {
            //         //this.checkAuth = true;
            //         responseData=true;
            //     }
            //     //this.isLoading = false;
            // }).catch(error => {
            //     console.log(error);
            //     //this.isLoading = false;
            //     responseData=false;
            // });

            
        },
        showMessage: function(typeMessage, title, detailMessage)
        {
            this.$swal.fire(
                title,
                detailMessage,
                typeMessage
            );
            return false;
        },
        checkFieldValidation(fieldName)
        {
            if(typeof(fieldName) != 'undefined')
            {
                if(fieldName == null)
                {
                    return true;
                }
                else if(fieldName.length == 0)
                {
                    return true;
                }
                else
                {
                    return false;
                } 
            }
            else 
            {
                return true;
            }
        },
        loadCartMixin: function(cartJsonString,cartPurchaseJsonString) {
            
            console.log('Mixin Load Cart Initiated');
            let cart = JSON.parse(cartJsonString);
            let purchaseCart = JSON.parse(cartPurchaseJsonString);
            console.log(cart);
            let cartItem={};
            if(cart != null)
            {
                cartItem.items=[];
                cart.items.forEach((row,index) => {
                    console.log(index, row);
                    row.image_path=this.$api+"assets/sell/device/category-device/"+row.deviceImage;
                    cartItem.items.push(row);
                });
                cartItem.total_price=cart.total_price;
                cartItem.total_quantity=cart.total_quantity;
            }
            

            
            console.log('purchase item ',purchaseCart);
            // console.log('purchase item ',purchaseCart.items.length);
            // console.log('purchase item type',typeof(purchaseCart.items));
            let cartPurchaseItem={};
            if(purchaseCart != null)
            {
                cartPurchaseItem.items=[];
                purchaseCart.items.forEach((row,index) => {
                    console.log(index, row);
                    row.image_path=this.$api+"assets/buy/device/info/"+row.deviceImage;
                    cartPurchaseItem.items.push(row);
                });
                
                cartPurchaseItem.total_price=purchaseCart.total_price;
                cartPurchaseItem.total_quantity=purchaseCart.total_quantity;
            }

            console.log(cartItem, cartPurchaseItem);      
            let dataResponse = {'cartItem':cartItem,'cartPurchaseItem':cartPurchaseItem};
            return dataResponse;      
        },
        getHomePageCMS: function () {
            var config = {
                method: "GET",
                url: this.$api + "api/geek-home-page-cms"
            };
            return this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    return {
                        'data':response.data.data, 
                        'whyUseUs':response.data.whyUseUs,
                        'bestReview':response.data.bestReview,
                        'dataFeature':response.data.dataFeature,
                        'startSelling':response.data.startSelling,
                        'sellellByCategory':response.data.sellellByCategory,
                    };
                }
            }).catch(error => {
                console.log(error);
            });
        },
        getSiteCMS: function() {
            var config = {
                method: "GET",
                url: this.$api + "api/geek-site-cms"
            };
            return this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    return response.data.data;
                }
            }).catch(error => {
                console.log(error);
            });
        }
    }
};
